// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.documents.LeaseDocumentsWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseDocumentsWebApiHandler_getExplainerLeaseForLease,
  LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Path,
  LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments,
  LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Path,
  LeaseDocumentsWebApiHandler_previewUrl,
  LeaseDocumentsWebApiHandler_previewUrl_Path,
} from '@zg-rentals/ts-leasing-client';

import type {
  GetExplainerLeaseForLeaseResponseDto,
  GetLandlordProvidedDocumentsResponseDto,
  LeaseArtifactType,
  PreviewUrlResponseDto,
} from '@zg-rentals/ts-leasing-client';

interface GetExplainerLeaseForLeaseParams {
  leaseId: number;
}
interface GetLandlordProvidedDocumentsParams {
  leaseId: number;
}
interface PreviewUrlParams {
  excludeAttachments?: boolean;
  leaseArtifactId: number;
  leaseArtifactType: LeaseArtifactType;
}

export type LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Options = UseQueryOptions<
  GetExplainerLeaseForLeaseResponseDto,
  unknown,
  GetExplainerLeaseForLeaseResponseDto,
  Array<string | GetExplainerLeaseForLeaseParams>
>;

const LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_GetKey = (getParams: GetExplainerLeaseForLeaseParams) => [
  LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Path,
  getParams,
];

/**
 * get explainer lease file name associated with specific lease
 */
export const useLeaseDocumentsWebApiHandler_getExplainerLeaseForLease = (
  getParams: GetExplainerLeaseForLeaseParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_GetKey(getParams),
    queryFn: () => LeaseDocumentsWebApiHandler_getExplainerLeaseForLease(getParams, httpClient),
  });
};
useLeaseDocumentsWebApiHandler_getExplainerLeaseForLease.getKey =
  LeaseDocumentsWebApiHandler_getExplainerLeaseForLease_GetKey;

export type LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Options = UseQueryOptions<
  GetLandlordProvidedDocumentsResponseDto,
  unknown,
  GetLandlordProvidedDocumentsResponseDto,
  Array<string | GetLandlordProvidedDocumentsParams>
>;

const LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_GetKey = (
  getParams: GetLandlordProvidedDocumentsParams,
) => [LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Path, getParams];

/**
 * get landlord provided document names
 */
export const useLeaseDocumentsWebApiHandler_getLandlordProvidedDocuments = (
  getParams: GetLandlordProvidedDocumentsParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_GetKey(getParams),
    queryFn: () => LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments(getParams, httpClient),
  });
};
useLeaseDocumentsWebApiHandler_getLandlordProvidedDocuments.getKey =
  LeaseDocumentsWebApiHandler_getLandlordProvidedDocuments_GetKey;

export type LeaseDocumentsWebApiHandler_previewUrl_Options = UseQueryOptions<
  PreviewUrlResponseDto,
  unknown,
  PreviewUrlResponseDto,
  Array<string | PreviewUrlParams>
>;

const LeaseDocumentsWebApiHandler_previewUrl_GetKey = (getParams: PreviewUrlParams) => [
  LeaseDocumentsWebApiHandler_previewUrl_Path,
  getParams,
];

/**
 * get preview lease url
 */
export const useLeaseDocumentsWebApiHandler_previewUrl = (
  getParams: PreviewUrlParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseDocumentsWebApiHandler_previewUrl_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeaseDocumentsWebApiHandler_previewUrl_GetKey(getParams),
    queryFn: () => LeaseDocumentsWebApiHandler_previewUrl(getParams, httpClient),
  });
};
useLeaseDocumentsWebApiHandler_previewUrl.getKey = LeaseDocumentsWebApiHandler_previewUrl_GetKey;
